var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContactForm',{staticClass:"!tw-p-4",attrs:{"form-url":_vm.url,"recaptcha-token":"info_contact","hide-title":"","placeholder-in-field":"","schema-path":"data.schema","data-path":null,"recipient-id":null}})}
var staticRenderFns = []

export { render, staticRenderFns }